(() => {
  if (window.serviceDesignInitialized) return;
  window.serviceDesignInitialized = true;
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-chart-unit]')) return;
    const chart = event.target.closest('[data-service-chart]');
    const from = chart.dataset.sourceUnit, to = event.target.value;
    const confirmed = ['cm', 'in'].includes(from);
    chart.querySelectorAll('[data-source-value]').forEach(cell => {
      const raw = cell.dataset.sourceValue.trim();
      const numeric = /^\d+(\.\d+)?$/.test(raw);
      cell.textContent = confirmed && numeric && from !== to
        ? String(Math.round(Number(raw) * (to === 'in' ? 1 / 2.54 : 2.54) * 10) / 10)
        : raw;
    });
    chart.querySelector('[data-chart-status]').textContent = confirmed
      ? 'Measurements shown in ' + (to === 'in' ? 'inches.' : 'centimeters.')
      : '[[TO BE CONFIRMED]]';
  });
})();
